module.exports = __webpack_public_path__ + "img/landing1.cfb7dec1.webp";